<template>
  <div class="page" :class="{ 'page--success': registroExitoso }" :style="bgStyle">
    <div class="main">
      <div class="panel">
        <!-- Header: Logo + Cerrar sesión (siempre visible) -->
        <div class="panel-header" :class="{ 'panel-header--success': registroExitoso }">
          <img
            :src="isMobile ? '/ejecutivo/logo movil.png' : '/ejecutivo/logotipo.png'"
            alt="Movistar Empresas"
            class="panel-logo"
          />
          <span class="topbar-logout" @click="cerrarSesion">Cerrar sesión</span>
        </div>

        <!-- ========== FORM VIEW ========== -->
        <template v-if="!registroExitoso">
          <!-- Welcome -->
          <h1 class="bienvenido font-light">Bienvenido,</h1>
          <p class="ejecutivo-info">
            <span class="ejecutivo-label">{{ ejecutivo.nombre || 'Ejecutivo' }}</span>
            <span class="ejecutivo-cac">{{ ejecutivo.idpdv_nombre || ejecutivo.cac }}</span>
          </p>

          <!-- Subtitle -->
          <p class="subtitulo">Pide al cliente la información que se detalla a continuación</p>

          <!-- Form -->
          <form @submit.prevent="enviar" class="formulario">
            <div class="grid-2col">
              <!-- Row 1 -->
              <div class="campo">
                <img src="/ejecutivo/nombre completo.png" class="campo-icono" />
                <input v-model="form.nombre_cliente" type="text" placeholder="Nombre completo" required />
              </div>
              <div class="campo">
                <img src="/ejecutivo/RFC.png" class="campo-icono" />
                <input v-model="form.rfc" type="text" placeholder="RFC (opcional)" />
              </div>

              <!-- Row 2 -->
              <div class="campo">
                <img src="/ejecutivo/telefono.png" class="campo-icono" />
                <input v-model="form.telefono" type="tel" placeholder="Teléfono (10 dígitos)" required maxlength="10" @input="soloNumeros" />
                <span v-if="telefonoError" class="campo-hint">{{ telefonoError }}</span>
              </div>
              <div class="campo">
                <img src="/ejecutivo/correo electronico.png" class="campo-icono" />
                <input v-model="form.correo_cliente" type="email" placeholder="Correo electrónico" required />
              </div>

              <!-- Row 3 -->
              <div class="campo">
                <img src="/ejecutivo/ciudad.png" class="campo-icono" />
                <select v-model="form.estado" required>
                  <option value="" disabled>Estado</option>
                  <option v-for="e in estados" :key="e" :value="e">{{ e }}</option>
                </select>
              </div>
              <div class="campo">
                <img src="/ejecutivo/cuantas lineas.png" class="campo-icono" />
                <input v-model="form.cuantas_lineas" type="text" inputmode="numeric" placeholder="¿Cuántas líneas requieres?" required @input="form.cuantas_lineas = form.cuantas_lineas.replace(/[^0-9]/g, '')" />
              </div>

              <!-- Row 4 -->
              <div class="campo">
                <img src="/ejecutivo/nombre empresa.png" class="campo-icono" />
                <input v-model="form.empresa" type="text" placeholder="Nombre de tu empresa" required />
              </div>
              <div class="campo">
                <img src="/ejecutivo/cuanto pagas.png" class="campo-icono" />
                <input v-model="form.cuanto_pagas" type="text" inputmode="numeric" placeholder="¿Cuánto pagas actualmente por línea?" required @input="form.cuanto_pagas = form.cuanto_pagas.replace(/[^0-9]/g, '')" />
              </div>

              <!-- Row 5 - Régimen -->
              <div class="campo">
                <img src="/ejecutivo/nombre empresa.png" class="campo-icono" />
                <select v-model="form.regimen">
                  <option value="" disabled>Régimen</option>
                  <option value="Persona Física con Actividad Empresarial">Persona Física con Actividad Empresarial</option>
                  <option value="Persona Moral">Persona Moral</option>
                </select>
              </div>

              <!-- Row 6 - Comentarios -->
              <div class="campo campo-full">
                <img src="/ejecutivo/comentarios.png" class="campo-icono" />
                <input v-model="form.observaciones" type="text" placeholder="Comentarios" />
              </div>
            </div>

            <p v-if="error" class="error">{{ error }}</p>
            <button type="submit" class="btn-enviar" :disabled="loading">
              {{ loading ? 'Enviando...' : 'Enviar' }}
            </button>
          </form>
        </template>

        <!-- ========== SUCCESS VIEW ========== -->
        <div v-else class="success-content">
          <div class="success-panel">
            <p class="ejecutivo-info ejecutivo-info--center">
              <span class="ejecutivo-label">{{ ejecutivo.nombre || 'Ejecutivo' }}</span>
              <span class="ejecutivo-cac">{{ ejecutivo.idpdv_nombre || ejecutivo.cac }}</span>
            </p>
            <img src="/ejecutivo/icono ok.png" alt="OK" class="ok-icon" />
            <h2 class="ok-titulo">Registro exitoso</h2>
            <p class="ok-texto">
              En un lapso de 24 horas, uno de nuestros consultores se pondrá en contacto
              vía telefónica con la empresa que acabas de registrar,
              para brindarle atención ágil y personalizada.
            </p>
            <button class="btn-enviar btn-nuevo-style" @click="nuevoRegistro">Nuevo registro</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      form: {
        nombre_cliente: '',
        telefono: '',
        empresa: '',
        rfc: '',
        correo_cliente: '',
        cuantas_lineas: '',
        cuanto_pagas: '',
        observaciones: '',
        estado: '',
        regimen: ''
      },
      estados: [
        'Aguascalientes', 'Baja California', 'Baja California Sur',
        'Campeche', 'Chiapas', 'Chihuahua', 'Coahuila', 'Colima',
        'CDMX', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo',
        'Jalisco', 'México', 'Michoacán', 'Morelos', 'Nayarit',
        'Nuevo León', 'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo',
        'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco',
        'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
      ],
      registroExitoso: false,
      loading: false,
      error: '',
      telefonoError: '',
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    ejecutivo() {
      return this.$store.getters.getEjecutivo || {};
    },
    bgStyle() {
      const img = this.isMobile ? '/ejecutivo/fondo_actual_movil.jpg' : '/ejecutivo/fondo_actual_pc.jpg';
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: this.isMobile ? 'top center' : 'left center'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    if (!this.$store.getters.isLoggedIn) this.$router.push('/login');
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    soloNumeros() {
      this.form.telefono = this.form.telefono.replace(/[^0-9]/g, '');
    },
    async enviar() {
      this.error = '';
      this.telefonoError = '';

      // Validar teléfono: solo números y 10 dígitos
      if (!/^\d{10}$/.test(this.form.telefono)) {
        this.telefonoError = 'El teléfono debe ser de 10 dígitos numéricos';
        return;
      }

      // Validar email
      if (this.form.correo_cliente) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.correo_cliente)) {
          this.error = 'Ingresa un correo electrónico válido';
          return;
        }
      }

      this.loading = true;
      try {
        const payload = {
          ...this.form,
          ciudad: this.form.estado,
          idpdv: this.ejecutivo.idpdv,
          axc: this.ejecutivo.axc,
          email_ejecutivo: this.ejecutivo.email,
          nombre_ejecutivo: this.ejecutivo.nombre,
          cac: this.ejecutivo.cac,
          origen: 'ejecutivo'
        };
        delete payload.estado;
        const res = await this.$api.post('ejecutivo/lead', payload);
        if (res.data.success) this.registroExitoso = true;
      } catch (err) {
        this.error = (err.response && err.response.data && err.response.data.message)
          ? err.response.data.message
          : 'Error al enviar, inténtalo de nuevo';
      } finally {
        this.loading = false;
      }
    },
    nuevoRegistro() {
      this.form = {
        nombre_cliente: '', telefono: '', empresa: '', rfc: '',
        correo_cliente: '', cuantas_lineas: '', cuanto_pagas: '',
        observaciones: '', estado: '', regimen: ''
      };
      this.registroExitoso = false;
      this.error = '';
      this.telefonoError = '';
    },
    cerrarSesion() {
      this.$store.commit('clearEjecutivo');
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  position: relative;
}

/* ============================
   PANEL HEADER - logo + cerrar sesión en fila
   ============================ */
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: clamp(24px, 3vw, 48px);
}

.panel-logo {
  height: clamp(70px, 8vw, 130px);
  width: auto;
}

.topbar-logout {
  color: rgba(255,255,255,0.75);
  font-size: clamp(12px, 1vw, 15px);
  cursor: pointer;
  font-family: TelefonicaRegular, sans-serif;
  white-space: nowrap;
}
.topbar-logout:hover {
  color: #fff;
  text-decoration: underline;
}

/* ============================
   MAIN
   ============================ */
.main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 20px 0;
  margin-left: 46vw;
}

.panel {
  width: 50vw;
  max-width: 750px;
  min-width: 340px;
}

/* ============================
   WELCOME TEXT
   ============================ */
.bienvenido {
  color: #fff;
  font-size: clamp(32px, 3.5vw, 54px);
  margin: 0 0 6px;
  line-height: 1.15;
}
.ejecutivo-info {
  color: #fff;
  font-size: clamp(18px, 1.8vw, 28px);
  margin: 0 0 4px;
}
.ejecutivo-label {
  font-weight: bold;
}
.ejecutivo-cac {
  font-size: clamp(12px, 1vw, 16px);
  font-weight: normal;
  opacity: 0.6;
  margin-left: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.ejecutivo-info--center {
  text-align: center;
  margin-bottom: 28px;
  white-space: nowrap;
}

/* ============================
   SUBTITLE
   ============================ */
.subtitulo {
  color: rgba(255,255,255,0.65);
  font-size: clamp(14px, 1.2vw, 18px);
  margin: clamp(14px, 1.6vw, 24px) 0 clamp(18px, 2vw, 30px);
  font-family: TelefonicaLight, sans-serif;
}

/* ============================
   FORM - 2 COLUMN GRID
   ============================ */
.formulario {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.grid-2col {
  width: 90%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(12px, 1.4vw, 22px);
}

.campo {
  position: relative;
}

.campo-full {
  grid-column: 1 / -1;
}

.campo-icono {
  position: absolute;
  left: clamp(12px, 1vw, 18px);
  top: 50%;
  transform: translateY(-50%);
  width: clamp(14px, 1.2vw, 20px);
  height: clamp(14px, 1.2vw, 20px);
  object-fit: contain;
  filter: brightness(0);
  opacity: 0.3;
}

.campo input,
.campo select {
  width: 100%;
  padding: clamp(10px, 0.8vw, 14px) clamp(14px, 1vw, 20px) clamp(10px, 0.8vw, 14px) clamp(34px, 2.8vw, 46px);
  border: none;
  border-radius: 30px;
  font-size: clamp(11px, 0.85vw, 14px);
  outline: none;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  font-family: TelefonicaRegular, sans-serif;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.campo select {
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 36px;
}

.campo input::placeholder {
  color: #aaa;
  font-size: clamp(11px, 0.85vw, 14px);
}

.campo input:focus,
.campo select:focus {
  background: #fff;
  box-shadow: 0 0 0 2px rgba(100, 180, 255, 0.4);
}

/* ============================
   CAMPO HINT (debajo del campo)
   ============================ */
.campo-hint {
  display: block;
  color: rgba(255,255,255,0.85);
  font-size: clamp(10px, 0.7vw, 12px);
  margin-top: 4px;
  padding-left: clamp(34px, 2.8vw, 46px);
  font-family: TelefonicaLight, sans-serif;
}

/* ============================
   ERROR
   ============================ */
.error {
  color: #ff6b6b;
  text-align: center;
  font-size: 12px;
  margin: 8px 0 0;
}

/* ============================
   BUTTON ENVIAR - pequeño y centrado
   ============================ */
.btn-enviar {
  width: clamp(120px, 12vw, 200px);
  padding: clamp(6px, 0.5vw, 10px);
  border: none;
  border-radius: 30px;
  background: #E535AB;
  color: #fff;
  font-size: clamp(12px, 0.9vw, 15px);
  cursor: pointer;
  transition: background 0.25s;
  margin-top: clamp(22px, 2.4vw, 38px);
  align-self: center;
  margin-left: -5%;
  font-family: TelefonicaRegular, sans-serif;
}
.btn-enviar:hover { background: #c92d96; }
.btn-enviar:disabled { opacity: 0.6; cursor: not-allowed; }

/* ============================
   SUCCESS VIEW
   ============================ */
.success-content {
  display: flex;
  justify-content: center;
  padding-top: clamp(30px, 4vw, 60px);
}
.success-panel {
  text-align: center;
  max-width: 520px;
  width: 90%;
}
.ok-icon {
  width: clamp(60px, 6vw, 90px);
  height: clamp(60px, 6vw, 90px);
  margin-bottom: 18px;
}
.ok-titulo {
  color: #fff;
  font-size: clamp(28px, 2.8vw, 42px);
  margin: 0 0 18px;
}
.ok-texto {
  color: rgba(255,255,255,0.8);
  font-size: clamp(14px, 1.2vw, 18px);
  line-height: 1.75;
  max-width: 500px;
  margin: 0 auto 32px;
  font-family: TelefonicaLight, sans-serif;
}
.btn-nuevo-style {
  margin-top: 0;
  margin-left: 0;
  align-self: auto;
}

/* ============================
   TABLET (769 - 1024)
   ============================ */
@media (min-width: 769px) and (max-width: 1024px) {
  .main {
    margin-left: 35vw;
  }
  .panel {
    width: 60vw;
  }
}

/* ============================
   MOBILE (<= 768)
   ============================ */
@media (max-width: 768px) {
  .page {
    flex-direction: column;
  }

  .panel-header {
    flex-direction: column;
    align-items: center;
    margin-bottom: 38vh;
    gap: 4px;
  }

  .panel-logo {
    height: auto;
    width: 260px;
  }

  .topbar-logout {
    font-size: 12px;
  }

  .main {
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 0;
    padding: 24px 28px 30px;
  }

  .panel {
    width: 100%;
    max-width: 340px;
    min-width: 0;
    margin: 0 auto;
  }

  .grid-2col {
    grid-template-columns: 1fr;
    gap: 10px;
    width: 100%;
  }

  .bienvenido {
    font-size: 24px;
    text-align: center;
  }
  .ejecutivo-info {
    font-size: 16px;
    text-align: center;
  }
  .ejecutivo-cac {
    display: block;
    margin-left: 0;
    margin-top: 2px;
  }
  .subtitulo {
    font-size: 13px;
    margin: 8px 0 14px;
    text-align: center;
  }
  .formulario {
    align-items: center;
  }

  .campo-icono {
    left: 14px;
    width: 15px;
    height: 15px;
  }
  .campo input,
  .campo select {
    padding: 12px 16px 12px 40px;
    font-size: 16px;
  }
  .campo input::placeholder {
    font-size: 16px;
  }

  .btn-enviar {
    width: 55%;
    padding: 10px;
    font-size: 14px;
    margin-top: 14px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  /* Success mobile */
  .success-content {
    padding-top: 10px;
    justify-content: center;
  }
  .success-panel {
    text-align: center;
  }
  .ejecutivo-info--center {
    text-align: center;
  }
  .ok-icon {
    width: 60px;
    height: 60px;
  }
  .ok-titulo {
    font-size: 22px;
  }
  .ok-texto {
    font-size: 13px;
    text-align: center;
  }
  .ok-titulo {
    text-align: center;
  }
  .btn-nuevo-style {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  /* Success mobile: contenido debajo del cubo, scroll si no cabe */
  .page--success {
    min-height: 100vh;
    overflow-y: auto;
  }
  .page--success .panel-header {
    margin-bottom: 0 !important;
    gap: 4px;
  }
  .page--success .panel-logo {
    display: none;
  }
  .page--success .topbar-logout {
    align-self: center;
    padding-top: 10px;
  }
  .page--success .main {
    padding: 0 24px 30px;
    margin-top: 52vh;
    align-items: center;
    justify-content: flex-start;
  }
  .page--success .panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    box-sizing: border-box;
  }
  .page--success .success-content {
    padding-top: 0;
    width: 100%;
  }
  .page--success .success-panel {
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
  }
  .page--success .ok-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
  }
  .page--success .ok-titulo {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .page--success .ok-texto {
    font-size: 13px;
    margin-bottom: 18px;
    line-height: 1.5;
  }
  .page--success .ejecutivo-info--center {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

/* Pantallas móviles pequeñas en altura (iPhone SE, 6, 7, 8) */
@media (max-width: 768px) and (max-height: 700px) {
  .panel-header {
    margin-bottom: 42vh !important;
  }
  .panel-logo {
    width: 200px !important;
  }
  .bienvenido {
    font-size: 20px !important;
  }
  .ejecutivo-info {
    font-size: 14px !important;
  }
  .subtitulo {
    font-size: 12px !important;
  }
}
</style>
